/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Try_Library_Roleplay_TitleInputs */



/**
* | output |
* | --- |
* | "Practice conversation" |
*
* @param {Nudge_Try_Library_Roleplay_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_try_library_roleplay_title = /** @type {((inputs?: Nudge_Try_Library_Roleplay_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Try_Library_Roleplay_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversation d'entraînement")
	return /** @type {LocalizedString} */ ("Practice conversation")
});